module.exports = __webpack_public_path__ + "static/media/search.9414d93b.svg";